import { Formik, Form, Field, ErrorMessage } from "formik";
import { InputMask } from "@react-input/mask";
import * as Yup from "yup";
import { useState } from "react";

import { _postByUrlData } from "../../service";
import hue from "./img/hue.webp";
import hueM from "./img/hue-m.webp";
import ButtonUI from "@UI/ButtonUI";

import ym from "react-yandex-metrika";

import "./style.scss";

const Footer = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);

    const handleSubmit = async (values, { resetForm }) => {
        ym("reachGoal", "contact_us");

        setIsSubmitting(true);
        const resp = await _postByUrlData("/landing_rispromo/ris_connect", values);
        if (resp.success) {
            resetForm();
            setIsSuccess(true);
            setTimeout(() => setIsSuccess(false), 4000);
        } else {
            setIsError(true);
            setTimeout(() => setIsError(false), 4000);
        }

        setIsSubmitting(false);
    };

    return (
        <div className="footer" id="footer">
            <img className="footer__hue" src={hue} alt="" />
            <img className="footer__hue-m" src={hueM} alt="" />
            <div className="footer__container">
                <div className="footer__content">
                    <div className="footer__left">
                        <span className="footer__title">Подключить RIS.Promo</span>
                    </div>
                    <Formik initialValues={{ email: "", fio: "", phone: "", site: "" }} validationSchema={validationSchema} onSubmit={handleSubmit}>
                        {({ errors, touched, isValid, dirty }) => (
                            <Form className="footer__form">
                                <div className={`footer__toast ${isSuccess ? "footer__toast_visible" : ""}`}>Ваша заявка отправлена! Мы ответим на указанную вами почту в ближайшее время.</div>
                                <div className={`footer__toast footer__toast_error ${isError ? "footer__toast_visible" : ""}`}>На сайте проводятся технические работы. Пожалуйста, попробуйте отправить запрос позже.</div>
                                <div className="footer__inputs">
                                    {fields.map((field, idx) =>
                                        field.name === "phone" ? (
                                            <Field key={idx} name="phone" component={CustomPhoneInput} />
                                        ) : (
                                            <div className={`footer__input ${touched[field.name] && errors[field.name] ? "footer__input-error" : ""}`} key={idx}>
                                                <Field type={field.type} name={field.name} placeholder={field.placeholder} className="footer__field" />
                                                <ErrorMessage name={field.name} component="div" className="footer__error" />
                                            </div>
                                        ),
                                    )}
                                </div>
                                <div className={`footer__block ${isSuccess || isError ? "footer__block_margin" : ""}`}>
                                    <span className="footer__policy">
                                        Нажимая на кнопку, вы даёте <a href="https://ris.promo/pdf/processing_of_personal_data.pdf">согласие на обработку персональных данных</a> и соглашаетесь с условиями{" "}
                                        <a href="https://ris.promo/pdf/privacy.pdf">Политики&nbsp;конфиденциальности</a>
                                    </span>
                                    <ButtonUI className="accept" disabled={!(isValid && dirty && !isSubmitting)} label={"Отправить запрос"} type="submit" />
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
                <div className="footer__info">
                    <span>
                        Если возникли вопросы, обращайтесь на <a href="mailto:info@ris.promo">info@ris.promo</a>
                    </span>
                    <a href="/pdf/it_agreement.pdf" target="_blank" rel="noopener noreferrer">
                        Требования Минцифры к сайтам ИТ-компаний
                    </a>
                </div>
            </div>
        </div>
    );
};

const fields = [
    { name: "email", type: "email", placeholder: "Ваша почта" },
    { name: "fio", type: "text", placeholder: "Ваше ФИО" },
    { name: "phone", type: "phone", placeholder: "+7 (___) ___-__-__" },
    { name: "site", type: "text", placeholder: "Сайт компании" },
];

const validationSchema = Yup.object({
    email: Yup.string().email("Введите корректный email").required("Поле email обязательно"),
    fio: Yup.string().min(2, "ФИО должно содержать минимум 2 символа").required("Поле ФИО обязательно"),
    phone: Yup.string()
        .matches(/^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/, "Введите корректный номер телефона")
        .required("Поле телефон обязательно"),
    site: Yup.string().min(2, "Сайт должен содержать минимум 2 символа").required("Поле сайт обязательно"),
});

const CustomPhoneInput = ({ field, form: { touched, errors } }) => (
    <div className={`footer__input ${touched[field.name] && errors[field.name] ? "footer__input-error" : ""}`}>
        <InputMask
            mask="+_ (___) ___-__-__"
            replacement={{ _: /\d/ }}
            {...field}
            placeholder="+7 (___) ___-__-__"
            className="footer__field"
            track={(val) => {
                if (val.inputType == "insert" && !val.selectionStart && !(val?.data?.length > 1)) return `+7${val.data}`;
            }}
        />
        {touched[field.name] && errors[field.name] && <div className="footer__error">{errors[field.name]}</div>}
    </div>
);

export default Footer;
